export const rateCardKeys = {
  all: () => ["rate-cards"] as const,
  detail: (rateCardId: string) => [...rateCardKeys.all(), rateCardId] as const,
};
